export default "__VITE_ASSET__CwJ4L7kY__"